import React from 'react';
import { StatusGlyph } from './MetricTile';
import type { KomGroup } from '../../lib/kom';

interface GroupBlockProps {
  group: Pick<KomGroup, 'id' | 'title' | 'status'>;
  children: React.ReactNode;
}

/** A titled block of metrics: what it is and its status (docs/c3/DESIGN.md). */
const GroupBlock: React.FC<GroupBlockProps> = ({ group, children }) => {
  const titleId = `c3-kom-group-${group.id}`;
  return (
    <section className="c3-kom-group" aria-labelledby={titleId}>
      <header className="c3-kom-group-head">
        <h3 id={titleId}>{group.title}</h3>
        {group.status ? (
          <span className={`c3-kom-status is-${group.status.tone}`}>
            <StatusGlyph icon={group.status.icon} />
            {group.status.text}
          </span>
        ) : null}
      </header>
      <div className="c3-kom-tiles">{children}</div>
    </section>
  );
};

export default GroupBlock;
